const taxPaths = {
  TAX: "",
  SEARCH_TAX_LIST: "search",
  TAX_ID: (id) => id,
};

export default taxPaths;
